import axios from 'axios';
import ActionTypes from '../constants/action-types';
import store from '../../redux/reducers/reducer';

export const getTrendings = (args) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_TRENDINGS_BUSY,
        payload: true
    });
    await axios.get(`/api/trendings`, {
        params: { ...args }
    })
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_TRENDING,
                payload: response.data.data,
            });

            dispatch({
                type: ActionTypes.SET_TRENDINGS_TOTAL,
                payload: response.data.total
            });

            dispatch({
                type: ActionTypes.SET_TRENDINGS_BUSY,
                payload: false
            });
        })
        .catch((error) => {
            console.error({ error });
            dispatch({
                type: ActionTypes.SET_TRENDINGS_BUSY,
                payload: false
            });
        });
};

export const setTrendingKeyword = payload => ({
    type: ActionTypes.SET_TRENDING_KEYWORD,
    payload
});

export const resetTrendings = payload => ({
    type: ActionTypes.RESET_TRENDINGS,
    payload
});

export const noReloadUpdateTrendings = payload => ({
    type: ActionTypes.NO_RELOAD_UPDATE_TRENDINGS,
    payload
});